export enum UserRoleEnum {
    SUPERADMIN = "SUPERADMIN",
    ADMIN = "ADMIN",
    PARTNER = "PARTNER",
    RESTRICTED_ACCESS = "RESTRICTED_ACCESS",
}
